import React from "react";
import {  useNavigate } from "react-router-dom";


const SingleBook = ({ book}) => {
  const navigate = useNavigate();

const handleClick = () => {
 const token = localStorage.getItem("userToken");
 if(token){
   navigate("/checkout", { state: { book } });
 }else{
   navigate("/login");
 }
};

  return (
    <div>
       <div onClick={handleClick}>
        <div className="book-card shadow-sm">
          <img
            className="book-img" crossOrigin="anonymous"
            src={`https://back.yourfrenchteachers.com/${book.cover}`}
          alt=""/>
          <div className="book-body">
            <h4 className="book-title">{book.title}</h4>
            <div className="book-footer">
              <p>{book.teacher}</p>
              <p className="book-price">{book.price} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleBook;
